export function extractAndMergeOptions<
  T extends Record<string, unknown>,
  S extends T,
>(options: Partial<S>, defaultOptions: Required<T>): Required<T> {
  // properties that also are in defaults are used to extract the options
  const properties = Object.keys(defaultOptions) as (keyof T)[];

  // override the default values with the provided options
  return properties.reduce(
    (acc, key) => {
      if (options[key] != null) {
        return { ...acc, [key]: options[key] };
      }
      return acc;
    },
    { ...defaultOptions },
  );
}
